module.exports = __webpack_public_path__ + "img/cpjs7.614e45b0.png";